module.exports = __webpack_public_path__ + "img/phone.d4bd9798.png";